import React, { useState } from "react";
import { createPortal } from "react-dom";


const CreatePipingScheduleModal = ({ isOpen, onClose, onSubmit }) => {
  const [propress, setPropress] = useState(false);
  const [grooved, setGrooved] = useState(false);
  const [pvc, setPVC] = useState(false);

  if (!isOpen) return null;

  // Use React Portal to render the modal at the document root
  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
      }}
    >
      <div className="relative bg-white p-8 rounded-lg shadow-lg w-full max-w-lg z-10">
        <div className="flex flex-col gap-4 mt-4">
          <div className="flex items-center justify-between">
            <label htmlFor="propress" className="text-md cursor-pointer">
              Check if you can use{" "}
              <span className="font-bold">Propress Fittings</span>
            </label>
            <input
              type="checkbox"
              id="propress"
              className="h-5 w-5 rounded border-gray-300 text-[#4F46E5] focus:ring-[#4F46E5] cursor-pointer"
              checked={propress}
              onChange={() => setPropress(!propress)}
            />
          </div>

          {/* <div className="flex items-center justify-between">
            <label htmlFor="grooved" className="text-md cursor-pointer">
              Check if you can use{" "}
              <span className="font-bold">Grooved Couplings</span>
            </label>
            <input
              type="checkbox"
              id="grooved"
              className="h-5 w-5 rounded border-gray-300 text-[#4F46E5] focus:ring-[#4F46E5] cursor-pointer"
              checked={grooved}
              onChange={() => setGrooved(!grooved)}
            />
          </div>

          <div className="flex items-center justify-between">
            <label htmlFor="pvc" className="text-md cursor-pointer">
              Check if you can use{" "}
              <span className="font-bold">PVC for plumbing piping</span>
            </label>
            <input
              type="checkbox"
              id="pvc"
              className="h-5 w-5 rounded border-gray-300 text-[#4F46E5] focus:ring-[#4F46E5] cursor-pointer"
              checked={pvc}
              onChange={() => setPVC(!pvc)}
            />
          </div> */}
        </div>

        <div className="flex flex-row gap-4 mt-10">
          <button
            className="bg-[#4F46E5] text-white px-4 py-2 rounded-md w-full"
            onClick={() => onSubmit({ propress, grooved, pvc })}
          >
            Create Schedule
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CreatePipingScheduleModal;
